import { googleCaptcha as googleCaptcha } from 'config';
import React from 'react';

import { getDisplayName } from 'src/utils/react';

export const withCaptcha = (WrappedComponent) => {
    return class extends React.Component {
        static displayName = `withCaptcha(${getDisplayName(WrappedComponent)})`;

        constructor (props) {
            super(props);

            this.state = {
                captchaReady: false,
            };

            this.wrappedComponent = React.createRef();

            this.providerPublicKey = null;
            this.loginKey = googleCaptcha.loginKey;
            this.registerKey = googleCaptcha.registerKey;
        }

        isEnabledCaptcha(id, callback) {
            // const sheet = document.styleSheets[0];
            // sheet.insertRule(".grecaptcha-badge { display: none; }", 1);

            this.providerPublicKey = id === "recaptcha-login" ? this.loginKey : this.registerKey;
            this.loadCaptcha(id, callback);
        }

        loadCaptcha(id, callback) {
            const { captchaReady } = this.state;

            if (typeof grecaptcha !== 'undefined' && this.providerPublicKey !== '') {
                grecaptcha.ready(() => {
                    if (!captchaReady) {
                        this.setState({
                            captchaReady: true
                        }, () => {
                            this.renderCaptcha(id, callback);
                        });
                    }
                });
            } else if (!captchaReady) {
                this.setState({
                    captchaReady: true
                }, () => {
                    this.renderCaptcha(id, callback);
                });
            }
        }

        renderCaptcha(id, callback) {
            if (typeof grecaptcha !== 'undefined' && this.providerPublicKey !== '') {
                grecaptcha.render(
                    id, {
                        sitekey: this.providerPublicKey,
                        callback,
                        size: 'invisible'
                    });
            }
        }

        throwCaptcha(callback) {
            if (typeof grecaptcha !== 'undefined' && this.providerPublicKey !== '') {
                grecaptcha.reset();
                grecaptcha.execute();
            } else {
                callback();
            }
        }

        resetCaptcha() {
            if (typeof grecaptcha !== 'undefined' && this.providerPublicKey !== '') {
                grecaptcha.reset();
            }
        }

        render () {
            return (<WrappedComponent
                ref={this.wrappedComponent}
                isEnabledCaptcha={this.isEnabledCaptcha.bind(this)}
                throwCaptcha={this.throwCaptcha.bind(this)}
                resetCaptcha={this.resetCaptcha.bind(this)}
                {...this.props}
            />);
        }
    };
};
